import './turbolinks-progress-bar.css'
